import './helper_functions';
import './docus_common';
import './number_pages';
import './time_records_msb';

// --------------------------------------------------------------
// ---------------------------- Various -------------------------
// --------------------------------------------------------------

import autosize from 'autosize';
window.autosize = autosize;

import sortable from './html5sortable';
window.sortable = sortable;
// $.fn.sortable = sortable;

import { number_pages } from './number_pages';
window.number_pages = number_pages;

import { sorter_ready } from "./badok_sortable";
window.sorter_ready = sorter_ready;
document.addEventListener("DOMContentLoaded", () => sorter_ready());

// --------------------------------------------------------------
// --------------------- helper_functions.js --------------------
// --------------------------------------------------------------

import * as helper_functions from './helper_functions';
window.upload_file_drag_drop = helper_functions.upload_file_drag_drop;
window.generate_pdf_from_table = helper_functions.generate_pdf_from_table;

// --------------------------------------------------------------
// ---------------------- docus_common.js -----------------------
// --------------------------------------------------------------
import * as docus_common from './docus_common';

window.docus_checklist_eval = docus_common.docus_checklist_eval;
window.count_docu_checkboxes_checked = docus_common.count_docu_checkboxes_checked;
window.count_docu_checkboxes_checked_except_none = docus_common.count_docu_checkboxes_checked_except_none;
window.get_checkboxes_results = docus_common.get_checkboxes_results;
window.cancel_all_docus_options_for_none = docus_common.cancel_all_docus_options_for_none;
window.cancel_docus_none_option = docus_common.cancel_docus_none_option;
window.evaluate_mandatory_fields = docus_common.evaluate_mandatory_fields;


// --------------------------------------------------------------
// ------------------------- Redfish.JS -------------------------
// --------------------------------------------------------------

import * as redfish from './redfish';

// ------------------- Person & Avatar -------------------
window.set_person_avatar = redfish.set_person_avatar;
window.set_h1_caption = redfish.set_h1_caption;
window.set_gendered_person_info = redfish.set_gendered_person_info;
window.bind_gender_watch = redfish.bind_gender_watch;
window.generateAvatarCircleFill = redfish.generateAvatarCircleFill;

// ------------------- UI Rendering ----------------------
window.paint_tr = redfish.paint_tr;
window.paint_fieldsets = redfish.paint_fieldsets;
window.set_all_fieldset_inner_to = redfish.set_all_fieldset_inner_to;
window.paint_overlap_region = redfish.paint_overlap_region;
window.highlightElement = redfish.highlightElement;
window.popup_window = redfish.popup_window;
window.dim_the_form = redfish.dim_the_form;
window.dimmed_element = redfish.dimmed_element;

// ------------------- Filters ---------------------------
window.sortable_ready = redfish.sortable_ready;
window.set_all_filter_handler_icons = redfish.set_all_filter_handler_icons;
window.set_filter_handler = redfish.set_filter_handler;
window.set_filter_handler_icon = redfish.set_filter_handler_icon;
window.has_filter = redfish.has_filter;

// ------------------- AJAX Lookups ----------------------
window.ajax_lookup_employments_institution = redfish.ajax_lookup_employments_institution;
window.ajax_lookup_employments_employee = redfish.ajax_lookup_employments_employee;
window.ajax_lookup_employments_employment_type = redfish.ajax_lookup_employments_employment_type;
window.ajax_lookup_employments_employment_mode = redfish.ajax_lookup_employments_employment_mode;
window.ajax_lookup_employments_employment_purpose = redfish.ajax_lookup_employments_employment_purpose;
window.ajax_lookup_access_certificate_valid_to = redfish.ajax_lookup_access_certificate_valid_to;
window.ajax_get_access_certificate_filename = redfish.ajax_get_access_certificate_filename;

// ------------------- Date & Time -----------------------
window.auto_correct_two_digit_year_in_birthdate = redfish.auto_correct_two_digit_year_in_birthdate;
window.auto_correct_two_digit_year_in_date = redfish.auto_correct_two_digit_year_in_date;

// ------------------- Utility & DOM Helpers -------------
window.compressArray = redfish.compressArray;
window.num_form_eval_errors = redfish.num_form_eval_errors;
window.GetProperty = redfish.GetProperty;
window.is_visible = redfish.is_visible;
window.docu_deactivator = redfish.docu_deactivator;
window.format_ajax_compliant = redfish.format_ajax_compliant;
window.encodeRFC5987ValueChars = redfish.encodeRFC5987ValueChars;
window.ElementHide = redfish.ElementHide;
window.ElementShow = redfish.ElementShow;
window.InnerHTML = redfish.InnerHTML;
window.escapeRegExp = redfish.escapeRegExp;
window.replaceAll = redfish.replaceAll;
window.Left = redfish.Left;
window.Right = redfish.Right;
window.format_comma = redfish.format_comma;
window.filename_to_title = redfish.filename_to_title;
window.compound_id = redfish.compound_id;

// ------------------- UI Busy State ---------------------
window.SetPageToBusy = redfish.SetPageToBusy;
window.SetPageToIdle = redfish.SetPageToIdle;
window.auto_hide = redfish.auto_hide;
window.AutoHideFlashZone = redfish.AutoHideFlashZone;

// ------------------- Task Overlap Visuals --------------
window.reset_overlap_images = redfish.reset_overlap_images;
window.focus_overlap_image = redfish.focus_overlap_image;
window.reset_overlap_radio = redfish.reset_overlap_radio;

// --------------------------------------------------------------
// ------------------- Time_Records_Common.JS -------------------
// --------------------------------------------------------------
import * as timeRecordsCommon from './time_records_common';

// Expose date/time utilities
window.init_datetimepicker = timeRecordsCommon.init_datetimepicker;
window.compose_datetime = timeRecordsCommon.compose_datetime;
window.compose_datetime______SIMPLE___________ = timeRecordsCommon.compose_datetime______SIMPLE___________;

window.moment_date = timeRecordsCommon.moment_date;
window.moment_time = timeRecordsCommon.moment_time;
window.moment_datetime = timeRecordsCommon.moment_datetime;
window.moment_date_validation = timeRecordsCommon.moment_date_validation;
window.moment_time_validation = timeRecordsCommon.moment_time_validation;
window.moment_datetime_validation = timeRecordsCommon.moment_datetime_validation;
window.moment_date_range_validation = timeRecordsCommon.moment_date_range_validation;
window.moment_time_range_validation = timeRecordsCommon.moment_time_range_validation;
window.moment_datetime_range_validation = timeRecordsCommon.moment_datetime_range_validation;
window.moment_date_in_year_validation = timeRecordsCommon.moment_date_in_year_validation;
window.moment_get_duration = timeRecordsCommon.moment_get_duration;
window.moment_set_weekday = timeRecordsCommon.moment_set_weekday;
window.moment_days_in_year = timeRecordsCommon.moment_days_in_year;
window.moment_correct_dauer_for_dst = timeRecordsCommon.moment_correct_dauer_for_dst;

window.lastSundayOfMonth = timeRecordsCommon.lastSundayOfMonth;

// UI Helpers
window.set_time_record_form_submit_button = timeRecordsCommon.set_time_record_form_submit_button;
window.set_clients_select_list_to_multiple = timeRecordsCommon.set_clients_select_list_to_multiple;
window.set_weekday = timeRecordsCommon.set_weekday;
window.set_workdays = timeRecordsCommon.set_workdays;
window.check_for_available_date = timeRecordsCommon.check_for_available_date;
window.get_available_docus = timeRecordsCommon.get_available_docus;
window.get_ziele_warning = timeRecordsCommon.get_ziele_warning;
window.get_docus_gascales_warning = timeRecordsCommon.get_docus_gascales_warning;
window.get_fehlkontakte_warning = timeRecordsCommon.get_fehlkontakte_warning;
window.get_contact_type = timeRecordsCommon.get_contact_type;
window.get_call_client_button = timeRecordsCommon.get_call_client_button;
window.get_client_data = timeRecordsCommon.get_client_data;
window.set_clients_select_list_to_multiple = timeRecordsCommon.set_clients_select_list_to_multiple;

// TimeRecord-specific AJAX interactions
window.ajax_set_session_pref = timeRecordsCommon.ajax_set_session_pref;
window.ajax_edit_time_record = timeRecordsCommon.ajax_edit_time_record;
window.ajax_get_tasks = timeRecordsCommon.ajax_get_tasks;
window.ajax_lookup_client = timeRecordsCommon.ajax_lookup_client;
window.ajax_lookup_institution = timeRecordsCommon.ajax_lookup_institution;
window.ajax_lookup_employee = timeRecordsCommon.ajax_lookup_employee;
window.ajax_lookup_project = timeRecordsCommon.ajax_lookup_project;
window.ajax_lookup_task = timeRecordsCommon.ajax_lookup_task;
window.ajax_lookup_contact_type = timeRecordsCommon.ajax_lookup_contact_type;
window.ajax_lookup_contact_status = timeRecordsCommon.ajax_lookup_contact_status;
window.ajax_lookup_fahrzeug = timeRecordsCommon.ajax_lookup_fahrzeug;
window.ajax_lookup_institution_filter = timeRecordsCommon.ajax_lookup_institution_filter;

// --------------------------------------------------------------
// ------------------- time_records_msb.js -------------------
// --------------------------------------------------------------
import * as timeRecordsMsb from './time_records_msb';

window.print_error = timeRecordsMsb.print_error;
window.clear_error = timeRecordsMsb.clear_error;
window.alert_von_bis = timeRecordsMsb.alert_von_bis;
window.reset_dauer = timeRecordsMsb.reset_dauer;
window.calculate_dauer = timeRecordsMsb.calculate_dauer;
window.calculate_vorort_dauer = timeRecordsMsb.calculate_vorort_dauer;
window.check_pause_between = timeRecordsMsb.check_pause_between;
window.check_betreuungszeiten = timeRecordsMsb.check_betreuungszeiten;
window.check_for_open_time_windows = timeRecordsMsb.check_for_open_time_windows;
window.check_for_completeness = timeRecordsMsb.check_for_completeness;
window.set_to_all_day = timeRecordsMsb.set_to_all_day;
window.show_anfahrt = timeRecordsMsb.show_anfahrt;
window.hide_anfahrt = timeRecordsMsb.hide_anfahrt;
window.show_rueckfahrt = timeRecordsMsb.show_rueckfahrt;
window.hide_rueckfahrt = timeRecordsMsb.hide_rueckfahrt;
window.show_kb = timeRecordsMsb.show_kb;
window.hide_kb = timeRecordsMsb.hide_kb;
window.set_msb_form_element_visibility = timeRecordsMsb.set_msb_form_element_visibility;
window.reset_values = timeRecordsMsb.reset_values;
window.reset_all_values = timeRecordsMsb.reset_all_values;
window.reset_hidden_values = timeRecordsMsb.reset_hidden_values;
window.prepare_msb_form_values = timeRecordsMsb.prepare_msb_form_values;
window.set_msb_time_form = timeRecordsMsb.set_msb_time_form;
window.paint_form = timeRecordsMsb.paint_form;
window.setup_form_for_add_mode = timeRecordsMsb.setup_form_for_add_mode;
window.setup_form_for_edit_mode = timeRecordsMsb.setup_form_for_edit_mode;
window.km_changed = timeRecordsMsb.km_changed;
window.time_changed = timeRecordsMsb.time_changed;